import { useQuery } from '@tanstack/react-query';
import { statisticsApi } from '../lib/api/statistics';

export const STATISTICS_QUERY_KEY = 'statistics';

export function useCourseStatistics(courseId: number) {
  return useQuery({
    queryKey: [STATISTICS_QUERY_KEY, courseId],
    queryFn: () => statisticsApi.getCourseStats(courseId),
    enabled: !!courseId,
  });
}

export function useGlobalStatistics() {
  return useQuery({
    queryKey: [STATISTICS_QUERY_KEY, 'global'],
    queryFn: statisticsApi.getGlobalStats,
  });
}

export function useActivity() {
  return useQuery({
    queryKey: [STATISTICS_QUERY_KEY, 'activity'],
    queryFn: () => statisticsApi.getActivity(105),
    retry: false,
    staleTime: 60_000,
  });
}
